import { Link } from 'react-router-dom';

const variants = {
  primary: 'border-2 border-dusty-rose text-chalk hover:bg-dusty-rose/20 bg-dusty-rose/10 uppercase tracking-[0.2em] font-bold shadow-lg',
  secondary: 'border-2 border-charcoal-dark text-chalk hover:bg-charcoal-dark/50 uppercase tracking-[0.2em] font-bold',
  outline: 'border-2 border-dusty-rose text-chalk hover:bg-dusty-rose/10 uppercase tracking-[0.2em] font-bold',
  white: 'border-2 border-dusty-rose/40 text-chalk hover:bg-dusty-rose/15 uppercase tracking-[0.2em] font-bold',
};

const sizes = {
  sm: 'px-6 py-2.5 text-[10px]',
  md: 'px-8 py-3.5 text-xs',
  lg: 'px-12 py-5 text-sm',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  to,
  href,
  className = '',
  ...props
}) {
  const baseClasses = `inline-flex items-center justify-center text-center rounded transition-all duration-500 ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className} hover:shadow-dusty-rose/10 hover:-translate-y-0.5 active:translate-y-0`;

  if (to) {
    return (
      <Link to={to} className={baseClasses} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={baseClasses} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button className={baseClasses} {...props}>
      {children}
    </button>
  );
}
